import React from 'react';
import { Camera, Star, Zap } from 'lucide-react';
export function BenefitsSection() {
  return <section className="py-24 bg-stone-900 text-white" data-id="element-1">
      <div className="container mx-auto px-4" data-id="element-2">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-3">
          <div className="order-2 lg:order-1" data-id="element-4">
            <img src="https://cdn.magicpatterns.com/uploads/vk5EWZSh2MyBeoHYAeKMMu/3.webp" alt="Calentadores negros de piel sintética con falda escalonada" className="w-full h-[700px] object-cover transition-all duration-700" data-id="element-5" />
          </div>

          <div className="order-1 lg:order-2 space-y-12" data-id="element-6">
            <div data-id="element-7">
              <h2 className="text-4xl md:text-5xl font-serif mb-6" data-id="element-8">
                Más que un accesorio, <br data-id="element-9" />
                <span className="italic text-stone-400" data-id="element-10">
                  es una decisión de identidad.
                </span>
              </h2>
              <p className="text-lg text-stone-300 leading-relaxed" data-id="element-11">
                Hay una diferencia enorme entre vestirse para cubrirse y
                vestirse para expresarse. Estos calentadores son para la mujer
                que entiende que la moda está en los detalles que los demás
                olvidan.
              </p>
            </div>

            <div className="space-y-8" data-id="element-12">
              <div className="flex gap-6 items-start" data-id="element-13">
                <div className="p-3 bg-stone-800 rounded-full shrink-0" data-id="element-14">
                  <Zap className="w-6 h-6 text-white" data-id="element-15" />
                </div>
                <div data-id="element-16">
                  <h3 className="text-xl font-serif font-bold mb-2" data-id="element-17">
                    Transformación Instantánea
                  </h3>
                  <p className="text-stone-400" data-id="element-18">
                    Eleva cualquier par de botas básicas a un nivel de pasarela.
                  </p>
                </div>
              </div>

              <div className="flex gap-6 items-start" data-id="element-19">
                <div className="p-3 bg-stone-800 rounded-full shrink-0" data-id="element-20">
                  <Camera className="w-6 h-6 text-white" data-id="element-21" />
                </div>
                <div data-id="element-22">
                  <h3 className="text-xl font-serif font-bold mb-2" data-id="element-23">
                    Fotogénicos por Naturaleza
                  </h3>
                  <p className="text-stone-400" data-id="element-24">
                    El volumen de la piel crea una silueta estética que destaca
                    en cualquier cámara.
                  </p>
                </div>
              </div>

              <div className="flex gap-6 items-start" data-id="element-25">
                <div className="p-3 bg-stone-800 rounded-full shrink-0" data-id="element-26">
                  <Star className="w-6 h-6 text-white" data-id="element-27" />
                </div>
                <div data-id="element-28">
                  <h3 className="text-xl font-serif font-bold mb-2" data-id="element-29">
                    Calidad Premium
                  </h3>
                  <p className="text-stone-400" data-id="element-30">
                    No pierden su forma ni su suavidad tras el uso.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}